module.exports = __webpack_public_path__ + "static/img/15.49798ef8.jpg";